import React, { useState, useEffect } from "react";
import groupdetail from "../../assets/images/BannerImage.jpg";
import SearchBar from "../../components/universal/SearchBar";
import Card from "./detailsPageCard";
import { FaAngleRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa";
import Navbar from "../../components/universal/Navbar";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { availableUsersAction, saveUserCircleAction } from "../../store/Users/UsersAction";
import { toast } from "react-toastify";
import MenuComponent from "../Circle/menu";
import { FiUser } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";

const Section = ({ title, items = [], linkPrefix = "", length }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="mt-4 relative z-30">
      <div className="flex justify-between items-center mb-6 max-w-[90%] mx-auto">
        <h3 className="text-xl font-semibold text-[#F8BA34]">{title}</h3>

        {items.length > 3 && (
          <button className="text-sm text-[#F8BA34] hover:underline flex items-center gap-2">
            See All <FaAngleRight />
          </button>
        )}
      </div>

      <div className="flex gap-4 overflow-x-auto ml-[5%] pb-2">
        {items.map((item, index) => (
          <Link
            key={index}
            to={`${linkPrefix}/${item?.details?._id || item?._id}`}
          >
            <Card data={item} length={length} prefix={linkPrefix} />
          </Link>
        ))}
      </div>
    </div>
  );
};

const GroupDetail = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get users from Redux store
  const users = useSelector((state) => state.user.users);
  const { userInfo } = useSelector((state) => state.user);

    const apiData = state?.apiData;

  const biblePlans = apiData?.biblePlan || [];
  const journals = apiData?.journals || [];
  const curriculums = apiData?.curriculums || [];
  const rawMembers = state?.members || []; // This should be the raw member objects
    // Helper function to get member avatars and names
  const getMemberData = (groupMembers = []) => {

    return groupMembers
      .filter(member => member != null)
      .map((member, index) => {
        // Get profile picture URL
        const profilePic =
          member?.details?.profilePicUrl ||
          member?.profilePicUrl ||
          member?.profilePic ||
          member?.user?.profilePicUrl ||
          `https://randomuser.me/api/portraits/${index % 2 === 0 ? "men" : "women"}/${(index % 50) + 1}.jpg`;

        // Get name (firstName + lastName)
        const firstName = member?.details?.firstName || member?.firstName || member?.user?.firstName || "";
        const lastName = member?.details?.lastName || member?.lastName || member?.user?.lastName || "";
        const name = `${firstName} ${lastName}`.trim() || `User ${index + 1}`;

        // Get email
        const email = member?.details?.email || member?.email || member?.user?.email || "";

        // Get TWG ID
        const twgId = member?.details?.twgId || member?.twgId || member?.user?.twgId || "";

        // Return full member object
        return {
          img: profilePic,
          name: name,
          firstName: firstName,
          lastName: lastName,
          email: email,
          twgId: twgId,
          originalData: member, // Keep original data
          id: member?.userAuthId || member?.id || index
        };
      });
  };

  // Get processed member data
  const memberData = getMemberData(rawMembers);

  // State for MenuComponent
  const [menuOpen, setMenuOpen] = useState(false);
  const [sentIds, setSentIds] = useState(new Set());
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [loading, setLoading] = useState(false);

  // State for profile card modal
  const [selectedMember, setSelectedMember] = useState(null);
  const [showProfileCard, setShowProfileCard] = useState(false);

  // Progression tracking analytics
  const [analytics, setAnalytics] = useState(null);
  const [loadingAnalytics, setLoadingAnalytics] = useState(false);

  useEffect(() => {
    const fetchAnalytics = async () => {
      setLoadingAnalytics(true);
      try {
        const token = localStorage.getItem("token");
        let baseUrl = process.env.REACT_APP_BASE_URL || "";
        if (baseUrl && !baseUrl.endsWith("/")) {
          baseUrl += "/";
        }
        const response = await fetch(`${baseUrl}groups/progress/analytics`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({ groupObjId: id, loggedinuser: userInfo?.userAuthId })
        });
        const resJson = await response.json();
        if (resJson.type === 1) {
          setAnalytics(resJson.data);
        }
      } catch (err) {
        console.error("Error fetching analytics", err);
      } finally {
        setLoadingAnalytics(false);
      }
    };

    if (id) {
      fetchAnalytics();
    }
  }, [id, userInfo]);

  // Handler for back button click
  const handleBackClick = () => {
    navigate(-1);
  };

  // Handler for member circle click - opens profile card
  const handleMemberClick = (member) => {
        setSelectedMember(member);
    setShowProfileCard(true);
  };

  // Close profile card
  const handleCloseProfileCard = () => {
    setShowProfileCard(false);
    setSelectedMember(null);
  };

  // Handler for Invite More button click
  const handleInviteMoreClick = (e) => {
    e.stopPropagation();

    // Calculate position for the menu
    const rect = e.currentTarget.getBoundingClientRect();
    setMenuPosition({
      x: rect.left,
      y: rect.bottom + 10
    });

    // Fetch available users first
    setLoading(true);
    dispatch(
      availableUsersAction({
        callback: (Data) => {
          setLoading(false);

          if (Data?.type === 1) {
                        setMenuOpen(true);
          } else {
            toast.error("Failed to load users");
          }
        }
      })
    );
  };

  // Handler for selecting a person from menu
  const handleSelectPerson = (person) => {

    dispatch(
      saveUserCircleAction({
        userAuthId: person.userAuthId,
        groupId: id,
        callback: (res) => {
          if (res.type === 1) {
            setSentIds((prev) => new Set(prev).add(person.userAuthId));
            toast.success(`${person.firstName} invited to group!`);
            setMenuOpen(false);
          } else {
            toast.error("Failed to invite user to group");
          }
        },
      })
    );
  };

  // Handler for adding a new user
  const handleAddUser = (data) => {
    dispatch(
      saveUserCircleAction({
        ...data,
        groupId: id,
        callback: (res) => {
          if (res.type === 1) {
            setSentIds((prev) => new Set(prev).add(data.userAuthId));
            toast.success(res.data?.message || "Invitation sent successfully!");
            setMenuOpen(false);
          } else {
            toast.error(res.error || "Failed to send invitation");
          }
        },
      })
    );
  };

  // Close menu
  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  // Optional: Fetch users on component mount
  useEffect(() => {
    dispatch(availableUsersAction({
      callback: (res) => {
              }
    }));
  }, [dispatch]);

  return (
    <div className="relative w-full overflow-hidden bg-black text-white pb-10">
      <SearchBar />
      <Navbar />

      <div className="md:ml-[104px]">
        <div className="relative w-full">
          <img
            src={apiData?.groupCoverImageUrl ?? groupdetail}
            alt="Group Banner"
            className="w-full h-[600px] object-cover"
          />

          {/* Gradient Overlay */}
          <div className="absolute inset-0 h-[600px] bg-gradient-to-t from-[#151515] via-[#15151599] to-transparent z-10" />

          {/* Circle Pill */}
          <div className="absolute top-4 left-4 z-20 flex items-center gap-8">
            <button
              onClick={handleBackClick}
              className="flex items-center justify-center w-10 h-10 bg-black/70 hover:bg-black text-[#F8BA34] rounded-full shadow-lg transition-all duration-300 hover:scale-110"
              aria-label="Go back"
            >
              <FaArrowLeft className="text-xl" />
            </button>
            <span className="bg-black text-[#F8BA34] px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
              {state?.apiData?.groupName}
            </span>
          </div>

          {/* Banner Content */}
          <div className="absolute bottom-10 left-[5%] z-20">
            <h2 className="text-3xl font-bold">
              {state?.apiData?.groupName}
            </h2>

            {/* Members - UPDATED with click handlers */}
            {memberData.length > 0 && (
              <div className="flex items-center mt-3 space-x-3">
                <div className="flex -space-x-2 items-center">
                  {memberData.slice(0, 5).map((member, index) => (
                    <div
                      key={member.id || index}
                      className="relative cursor-pointer group"
                      onClick={() => handleMemberClick(member)}
                    >
                      <img
                        src={member?.originalData?.img ??member.img}
                        alt="Member"
                        className="w-10 h-10 rounded-full border-2 border-white hover:border-[#F8BA34] transition-all duration-300 hover:scale-110"
                      />
                      {/* Hover tooltip */}
                      <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-black/90 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-50 pointer-events-none">
                        {member.name}
                      </div>
                    </div>
                  ))}

                  {memberData.length > 5 && (
                    <div className="h-fit bg-[#F8BA34] text-black font-bold px-3 py-1 rounded-full text-sm cursor-pointer hover:bg-yellow-500 transition-colors">
                      +{memberData.length - 5}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Invite Button */}
            <button
              onClick={handleInviteMoreClick}
              disabled={loading}
              className="mt-4 px-5 py-2 border border-white rounded-full font-semibold hover:bg-gray-200 hover:text-black transition flex items-center gap-2"
            >
              {loading ? (
                <>
                  <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
                  Loading...
                </>
              ) : (
                <>
                  <FiUser className="text-sm" />
                  Invite More
                </>
              )}
            </button>
          </div>
        </div>

        {/* Sections */}
        <div className="-mt-16 relative z-30 pt-10">
          <Section
            title="Bible Plans"
            items={biblePlans}
            linkPrefix="/plan"
            length={biblePlans.length}
          />
          <Section
            title="Journals"
            items={journals}
            linkPrefix="/journal"
            length={journals.length}
          />
          <Section
            title="Curriculums"
            items={curriculums}
            linkPrefix="/curriculum"
            length={curriculums.length}
          />
        </div>

        {/* Progress Dashboard */}
        <div className="max-w-[90%] mx-auto mt-12 bg-neutral-900/60 border border-neutral-800 rounded-3xl p-8 relative z-30 backdrop-blur-md">
          <h3 className="text-2xl font-bold text-[#F8BA34] mb-6">Group Progress Dashboard</h3>

          {loadingAnalytics ? (
            <div className="flex justify-center items-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#F8BA34]"></div>
            </div>
          ) : analytics ? (
            <div className="flex flex-col lg:flex-row gap-8 text-white">
              {/* Left Side: Circular Progress */}
              <div className="flex flex-col items-center justify-center bg-neutral-950 p-6 rounded-2xl border border-neutral-800 w-full lg:w-1/3">
                <div className="relative flex items-center justify-center w-36 h-36">
                  {/* Outer circle track */}
                  <svg className="w-full h-full transform -rotate-90">
                    <circle
                      cx="72"
                      cy="72"
                      r="60"
                      className="text-neutral-800"
                      strokeWidth="10"
                      stroke="currentColor"
                      fill="transparent"
                    />
                    <circle
                      cx="72"
                      cy="72"
                      r="60"
                      className="text-[#F8BA34]"
                      strokeWidth="10"
                      strokeDasharray={376.8}
                      strokeDashoffset={376.8 - (376.8 * (analytics.groupProgress || 0)) / 100}
                      strokeLinecap="round"
                      stroke="currentColor"
                      fill="transparent"
                    />
                  </svg>
                  <span className="absolute text-3xl font-extrabold">{analytics.groupProgress || 0}%</span>
                </div>
                <p className="mt-4 text-sm text-neutral-400 font-semibold uppercase tracking-wider">Overall Completion</p>
                <div className="flex justify-around w-full mt-6 border-t border-neutral-800 pt-4 text-center">
                  <div>
                    <span className="text-xl font-bold text-white">{memberData.length}</span>
                    <p className="text-xs text-neutral-400">Members</p>
                  </div>
                  <div>
                    <span className="text-xl font-bold text-white">
                      {(apiData?.biblePlan?.length || 0) + (apiData?.journals?.length || 0) + (apiData?.curriculums?.length || 0)}
                    </span>
                    <p className="text-xs text-neutral-400">Attached Items</p>
                  </div>
                </div>
              </div>

              {/* Right Side: Member & Content Progress */}
              <div className="flex-1 flex flex-col gap-6">
                {/* Member Progress List */}
                <div className="bg-neutral-950/80 border border-neutral-800 rounded-2xl p-6">
                  <h4 className="text-lg font-bold mb-4 text-[#F8BA34]">Member Progress</h4>
                  <div className="overflow-x-auto max-h-[300px]">
                    <table className="w-full text-left text-xs border-collapse">
                      <thead>
                        <tr className="border-b border-neutral-800 text-neutral-400 uppercase font-semibold">
                          <th className="py-2 px-3">Member</th>
                          <th className="py-2 px-3">Completed Items</th>
                          <th className="py-2 px-3 text-right">Completion</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(analytics.memberProgress || []).map((m, idx) => (
                          <tr key={idx} className="border-b border-neutral-800/50 hover:bg-neutral-900/40">
                            <td className="py-3 px-3 flex items-center gap-3">
                              <img
                                src={m.profilePicUrl || `https://randomuser.me/api/portraits/men/${idx + 1}.jpg`}
                                alt={m.firstName}
                                className="w-8 h-8 rounded-full object-cover border border-neutral-700"
                              />
                              <div>
                                <div className="font-bold text-white">{m.firstName} {m.lastName}</div>
                                <div className="text-[10px] text-neutral-500">{m.userAuthId}</div>
                              </div>
                            </td>
                            <td className="py-3 px-3 text-neutral-300 font-semibold">
                              {m.completedCount} / {m.totalCount}
                            </td>
                            <td className="py-3 px-3 text-right font-extrabold text-[#F8BA34]">
                              {m.progress}%
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Content Progress List */}
                <div className="bg-neutral-950/80 border border-neutral-800 rounded-2xl p-6">
                  <h4 className="text-lg font-bold mb-4 text-[#F8BA34]">Content Completion</h4>
                  <div className="flex flex-col gap-4 max-h-[300px] overflow-y-auto pr-2">
                    {(analytics.contentProgress || []).map((item, idx) => (
                      <div key={idx} className="flex flex-col gap-1">
                        <div className="flex justify-between text-xs font-semibold">
                          <span className="truncate max-w-[60%] text-neutral-200">{item.title}</span>
                          <span className="text-neutral-400 uppercase text-[9px] bg-neutral-800 px-2 py-0.5 rounded-full">{item.contentType}</span>
                          <span className="text-[#F8BA34] font-bold">{item.progress}%</span>
                        </div>
                        <div className="w-full bg-neutral-800 h-2 rounded-full overflow-hidden">
                          <div className="bg-[#F8BA34] h-full rounded-full" style={{ width: `${item.progress}%` }}></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <p className="text-center text-neutral-500 py-6 text-sm">No progression data available yet.</p>
          )}
        </div>
      </div>

      {/* Profile Card Modal */}
      {showProfileCard && selectedMember && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[99999] p-4">
          <div className="bg-[#1F1F1F] rounded-3xl w-full max-w-md overflow-hidden shadow-2xl relative">
            {/* Close button */}
            <div className="absolute top-4 right-4 z-50">
              <button
                onClick={handleCloseProfileCard}
                className="w-10 h-10 rounded-full bg-black/70 hover:bg-black flex items-center justify-center transition-colors"
                aria-label="Close"
              >
                <IoMdClose className="text-white text-xl" />
              </button>
            </div>

            {/* Profile Content */}
            <div className="px-8 py-10 flex flex-col items-center">
              {/* Large Circle Image */}
              <div className="mb-6">
                <div className="w-48 h-48 rounded-full border-4 border-[#F8BA34] overflow-hidden">
                  <img
                    src={selectedMember?.originalData?.img ?? selectedMember.img}
                    alt={selectedMember.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              {/* Name */}
              <h2 className="text-3xl font-bold text-center text-white mb-2">
                {selectedMember.name}
              </h2>

            </div>
          </div>
        </div>
      )}

      {/* Floating Menu (Invite Users) */}
      {menuOpen && (
        <div
          className="fixed z-[9999]"
          style={{
            top: `10%`,
            left: `20%`,
          }}
        >
          <MenuComponent
            users={users}
            onSelect={handleSelectPerson}
            onClose={handleCloseMenu}
            onAddUser={handleAddUser}
            sentIds={sentIds}
            title={`Invite to ${state?.apiData?.groupName}`}
          />
        </div>
      )}
    </div>
  );
};

export default GroupDetail;